import React from 'react';
import { Button, CircularProgress, Grid, Typography } from '@mui/material';
import { useForm } from 'react-hook-form';
import { useFlashMessageContext } from '../../contexts/flashMessage';
import { buildUrl, SITE_TITLE } from '../../utils';
import InputField from '../forms/InputField';

type ForgotPasswordFormProps = {
  onSwitchForm: (formToShow: 'LOGIN' | 'CREATE_ACCOUNT' | 'FORGOT_PASSWORD') => void;
};

export default function ForgotPasswordForm({ onSwitchForm }: ForgotPasswordFormProps) {
  const { addFlashMessage, clearFlashMessage } = useFlashMessageContext();
  const {
    control,
    handleSubmit,
    formState: { isSubmitting },
  } = useForm({
    defaultValues: {
      email: '',
    },
  });

  return (
    <form
      onSubmit={handleSubmit(({ email }) => {
        clearFlashMessage();
        return fetch(buildUrl('/api/forgot-password'), {
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          method: 'POST',
          mode: 'cors',
          body: JSON.stringify({ email }),
        }).then(response => {
          if (response.status === 204) {
            addFlashMessage('success', 'A link to reset your password has been sent to your email');
            return;
          }
          if (response.status === 400) {
            return response.json().then(responseData => addFlashMessage('warning', responseData.detail));
          }
          addFlashMessage('error', 'An unknown error occurred');
        });
      })}
    >
      <Grid container spacing={2} sx={{ textAlign: 'center' }}>
        <Grid item xs={12}>
          <Typography variant="h3">{SITE_TITLE}</Typography>
        </Grid>
        <Grid item xs={12}>
          <InputField
            control={control}
            label="Email"
            name="email"
            rules={{ required: 'Required' }}
            sx={{ width: '100%' }}
            type="email"
          />
        </Grid>
        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Button onClick={() => onSwitchForm('LOGIN')}>Go Back to Login</Button>
          <Button type="submit" variant="contained" disabled={isSubmitting}>
            {isSubmitting ? <CircularProgress size={24} /> : 'Send Link to Reset Password'}
          </Button>
        </Grid>
      </Grid>
    </form>
  );
}
